var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShipping(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 177.65 204.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#966631;}.cls-2{fill:#80572a;}.cls-3{fill:#6d4a24;}.cls-4{fill:#c98842;}.cls-5{fill:#ce9354;}.cls-6{fill:#a06d35;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "177.65 50.92 177.34 153.31 88.83 204.78 88.83 102.21 177.65 50.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "88.83 102.21 88.83 204.78 .32 153.31 0 50.92 88.83 102.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "177.65 50.92 140.54 72.35 133.52 76.4 132.97 76.72 127.13 80.09 126.25 80.6 88.83 102.21 0 50.92 36.16 27.93 42.93 23.62 42.94 23.62 43.16 23.49 44.01 23.05 50.51 19.71 88.83 0 177.65 50.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "140.56 72.36 133.51 76.42 132.98 76.73 127.13 80.09 126.25 80.6 36.16 27.93 42.93 23.62 42.94 23.62 43.16 23.49 43.97 23.03 44.01 23.05 50.51 19.71 140.54 72.35 140.56 72.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "133.76 75.99 133.52 76.4 133.51 76.42 133.24 76.88 132.98 76.73 132.97 76.72 42.94 23.62 43.16 23.49 43.97 23.03 44.01 23.05 133.76 75.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "176.64 51.53 176.63 52.75 89.83 102.87 89.83 101.67 176.64 51.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "126.25 80.6 126.25 104 140.56 95.68 140.56 72.36 126.25 80.6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipping);
export default __webpack_public_path__ + "static/media/shipping.b4f5747f3d0dbb3e66123658277b8e5c.svg";
export { ForwardRef as ReactComponent };